import { Component, HostListener } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';

// Page created by Kowsalya

@Component({
	selector: 'confirmation-timeout',
	templateUrl: 'confirmation-timeout.component.html'
})
export class timeoutconfirmation {

    vStatus: boolean;
    constructor(
        private _layoutService: LayoutService,
      
	){}
    
    ngOnInit(){
        this._layoutService.setCurrentPage('confirmation-cancel');
        //this._layoutService.vLayoutState.appPPMFlowHeader = true;
        //this._layoutService.vPlantmapCurrentState = this._layoutService.vPlantmapFlow.indexOf('confirmation-cancel');
        this.vStatus = true;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/confirmation-timeout.component.ts